<template>
  <el-select v-model="selectValue" @change="changeOption"
             :disabled="onlyOne || disabled" :clearable="clearable" placeholder="请选择"
             class="common-width">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"/>
  </el-select>
</template>

<script>
export default {
  name: "AppSelect",
  data() {
    return {
      selectValue: this.appId,
      onlyOne: false,
      list: [],
    }
  },
  props: {
    /**
     * 默认选中值
     */
    appId: {
      required: false,
      type: [Number, String]
    },
    /**
     * 应用类型
     *  1-"智兑" 2-"智收" 3-"智维"
     *  4-"智服" 5-"智培" 0-"未知"
     */
    appType: {
      required: false,
      type: [Number, String],
      default: undefined
    },
    /**
     * 是否可用
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示全部
     */
    all: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许清除
     */
    clearable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    appId: {
      handler(newVal) {
        if (newVal != null && newVal !== '') {
          this.selectValue = newVal
        } else {
          this.selectValue = null
          this.initData()
        }
      },
      immediate: true
    },
  },
  created() {
    this.initData()
  },
  methods: {
    changeOption(item) {
      this.$emit("update:appId", item);
    },
    initData() {
      this.$http({
        url: this.$http.adornUrl('/sys/app/simple-list'),
        method: 'get',
        params: this.$http.adornParams(this.appType ? {type: this.appType} : {})
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.list = data.data
          if (this.list != undefined && this.list.length == 1 && this.appId != undefined) {
            this.selectValue = this.list[0].id
            this.onlyOne = true
            this.$emit("update:appId", this.selectValue);
          }
          if (this.all) {
            this.list.unshift({name: "全部", value: null})
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app/app-select.vue